export const SELECT_LOCATION_CHANGE_STATE = 'SELECT_LOCATION_CHANGE_STATE';

export default function setSelectLocationChange(payload) {
  return {
    type: SELECT_LOCATION_CHANGE_STATE,
    payload,
  };
}
